<template>
  <section class="magazine-text">
    <div class="magazine-text__header">
    <h2>
      <TextHeading variant="magazineintro">{{ title }}</TextHeading>
      </h2>
    </div>
    <div class="magazine-text__body">
      <p>This is the third article of a three-part series. I'm illustrating the marketing challenges of PrescottWeddings.com, a small business. If you don't remember anything else about marketing, remember this: Frequency is king.</p>
      <p>The more often you can get your name in front of your potential and current customers, the more likely you will make a sale.</p>
      <p>Depending on what study you look at, people need to see your message anywhere from three to 27 times before they act upon it. And, if you want to brand your business.</p>
      <p>Then you need to get it in front of your customers as often as possible.</p>
    </div>
  </section>
</template>

<script>
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'MagazineMainText',
  components: {
    TextHeading
  },
  props: {
    title: {
      type: String,
      default:
        'Our team of chefs and product developers have once again been busy creating to make every product perfect this year.'
    }
  }
}
</script>

<style lang="postcss">
.magazine-text {
  @apply flex flex-wrap flex-col;
}
.magazine-text__header {
  @apply w-full mb-4 text-center;
}
.magazine-text__body {
  @apply w-full text-center hidden;
}
.magazine-text__body p {
  @apply mb-4;
}
.magazine-text__body p:last-of-type {
  @apply mb-0;
}
.christmas-app-no-overlay .magazine-text__header  {
    @apply max-w-4xl pt-8 pb-4;
  }
.christmas-app-no-overlay .magazine-text__header .heading--magazineintro {
    @apply text-xl;
  }
@screen md {
  .christmas-app-no-overlay .magazine-text__header .heading--magazineintro {
    @apply text-xl;
  }
}

@screen lg {
  .christmas-app-no-overlay .magazine-text__header .heading--magazineintro {
    @apply text-3xl;
  }
  .magazine-text {
    @apply flex-no-wrap;
  }
  .magazine-text__header {
    @apply mb-8 mr-auto ml-auto flex-1;
  }
  .christmas-app-no-overlay .magazine-text__header  {
    @apply pt-12 pb-6;
  }
  .magazine-text__body {
    @apply flex-1 hidden;
  }
  .magazine-text__body p {
    @apply mb-2 text-lg;
  }
}
</style>
